import styled from 'styled-components';

const BannerSectionStyle = styled.section`
	--componentPatTB: var(--sp13x);
	--marginDistance: var(--sp6x);
	--bannerFileMTop: var(--sp6x);
	--fileSectionBorderRadius: var(--sp4x);
	--fileSize: 59.6%;

	/* padding: var(--componentPatTB) 0; */
	padding: var(--sectionDistance) 0;
	background-color: var(--green1000);

	.normal-text,
	.styled-text {
		color: var(--lightGray1000);
	}

	.styled-text-wrapper {
		text-align: center;
	}

	.editor-wrapper {
		text-align: center;
		margin-top: var(--marginDistance);

		* {
			color: var(--lightGray1000);
		}
	}

	.banner-file {
		margin-top: var(--descBannerDistance);
	}

	.file-container {
		--fileHeight: var(--fileSize);
	}

	.file-section {
		overflow: hidden;
		border-radius: var(--fileSectionBorderRadius);
	}

	.inner-wrap-title {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--componentPatTB: var(--sp10x);
		--marginDistance: var(--sp5x);
		--bannerFileMTop: var(--sp5x);
		--fileSectionBorderRadius: var(--sp3x);
		--fileSize: 59.7%;
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--componentPatTB: var(--sp8x);
		--marginDistance: var(--sp4x);
		--bannerFileMTop: var(--sp4x);
		--fileSectionBorderRadius: var(--sp3x);
		--fileSize: 59.6%;
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--componentPatTB: var(--sp7x);
		--marginDistance: var(--sp4x);
		--bannerFileMTop: var(--sp4x);
		--fileSectionBorderRadius: var(--sp3x);
		--fileSize: 59.7%;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--componentPatTB: var(--sp6x);
		--marginDistance: var(--sp4x);
		--bannerFileMTop: var(--sp4x);
		--fileSectionBorderRadius: var(--sp3x);
		--fileSize: 59.8%;
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--componentPatTB: var(--sp5x);
		--marginDistance: var(--sp4x);
		--bannerFileMTop: var(--sp4x);
		--fileSectionBorderRadius: var(--sp2x);
		--fileSize: 61%;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--componentPatTB: var(--sp5x);
		--marginDistance: var(--sp4x);
		--bannerFileMTop: var(--sp4x);
		--fileSectionBorderRadius: var(--sp1-5x);
		--fileSize: 60.3%;
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--componentPatTB: var(--sp4x);
		--marginDistance: var(--sp3x);
		--bannerFileMTop: var(--sp3x);
		--fileSectionBorderRadius: var(--sp1x);
		--fileSize: 59%;
	}
`;

export default BannerSectionStyle;
